import { MONTHS_RU } from "@/shared/consts";

function getLastDayOfMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

export function formatDateRange(startDate: string, endDate: string): string {
  const [sy, sm, sd] = startDate.split("-").map(Number);
  const [ey, em, ed] = endDate.split("-").map(Number);

  if (sy === ey && sm === 1 && sd === 1 && em === 12 && ed === 31) {
    return `${sy} год`;
  }

  if (sy === ey && sm === em && sd === 1 && ed === getLastDayOfMonth(ey, em)) {
    return `${MONTHS_RU[sm - 1]} ${sy}`;
  }

  const fmt = (d: number, m: number, y: number) =>
    `${String(d).padStart(2, "0")}.${String(m).padStart(2, "0")}.${y}`;

  return `${fmt(sd, sm, sy)} — ${fmt(ed, em, ey)}`;
}
